<template>
  <div class="spec-note-comp">
    <div class="spec-note-comp__title-container">
      <div class="spec-note-comp__title-purple-box">
      </div>
      <p class="spec-note-comp__title">
        Notowania specjalne
      </p>
    </div>
    <div
      class="spec-note-comp__banner-list"
      v-for="(banner, index) in bannerList"
      :key="index"
    >
      <Banner :photo="banner.photo" :site="banner.link"/>
    </div>
  </div>
</template>

<script>
  import Banner from '@/components/Banner/Mobile/Banner.vue';
  import mixin from '../mixin';

  export default {
    mixins: [mixin],
    components: {
      Banner
    }
  }
</script>

<style scoped lang="scss">
  .spec-note-comp {
    display: flex;
    align-items: center;
    flex-direction: column;
    &__title-container {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      margin-top: 2rem;
      width: 100%;
    }
    &__title-purple-box {
      width: 1.2rem;
      height: 1.2rem;
      background-color: #df2860;
      margin-right: 1rem;
    }
    &__title {
      font-family: 'Poppins', sans-serif;
      color: #0f1626;
      font-size: 1.6rem;
      line-height: 1.2;
      font-weight: 700;
      text-transform: uppercase;
    }
    &__banner-list {
      width: 100%;
    }
  }
</style>
